import { ValueLabel } from "../models/ValueLabel";

export const EDUCATION_OPTIONS: ValueLabel[] = [
  { value: "زیردیپلم", label: "زیردیپلم" },
  { value: "دیپلم", label: "دیپلم" },
  { value: "فوق دیپلم", label: "فوق دیپلم" },
  { value: "کارشناسی", label: "کارشناسی" },
  { value: "کارشناسی ارشد", label: "کارشناسی ارشد" },
  { value: "دکتری", label: "دکتری" },
  { value: "حوزوی", label: "حوزوی" },
];
